import { get } from 'framework/api/http';
import { useMutation } from 'react-query';

interface GetCCDashboardActivityInMinsInterface {
  startDate: string;
  endDate: string;
  id: string;
}

export const useGetCCActivityInMins = () => {
  const mutate = useMutation(
    ({ startDate, endDate, id }: GetCCDashboardActivityInMinsInterface) => {
      return get(`/external-api/get_views_with_range/${id}/${startDate}/${endDate}`);
    },
  );

  return mutate;
};

export default useGetCCActivityInMins;
